'use client'

import { Builder, withChildren } from '@builder.io/react'

import { getLocalePaths } from '@src/i18n/locale.util'
import { visibilityInputs } from '@src/utils/builder.util'

import { ConditionalBox } from './ConditionalBox'

Builder.registerComponent(withChildren(ConditionalBox), {
  name: 'ConditionalBox',
  noWrap: true,
  image: 'https://unpkg.com/@tabler/icons@2.44.0/icons/box-margin.svg',
  inputs: [
    ...visibilityInputs({
      locale: getLocalePaths(),
      queryParams: 'queryParams',
      experiment: 'experiment',
      loggedIn: 'loggedIn',
      hasBodiAccess: 'hasBodiAccess',
      sku: 'sku',
    }),
    {
      name: 'includedChildren',
      type: 'array',
      hideFromUI: true,
      subFields: [
        {
          name: 'item',
          type: 'uiBlocks',
          defaultValue: [],
        },
      ],
      defaultValue: [
        {
          item: [],
        },
      ],
    },
  ],
})
